import React, { useCallback, useState, useEffect } from 'react';
import CreateImageItem from '../components/CreateImageItem';
import CreateTextItem from '../components/CreateTextItem';

export default function PastedItemView({
  onAdd,
  onCancel,
  className = '',
  pastedItems = [],
  folderOptions = [],
  defaultFolderId = null
}) {
  const [pastedType, setPastedType] = useState(null);
  const [pastedText, setPastedText] = useState(null);

  const loadPastedText = useCallback(async (blob) => {
    if (!blob) return;
    const text = await blob.text();
    setPastedText(text);
  }, []);

  useEffect(() => {
    if (pastedItems.length === 0) return;

    console.log(URL.createObjectURL(pastedItems[0]));

    let hasImage = false;
    let hasText = false;

    for (const item of pastedItems) {
      if (item.type.startsWith('image/')) {
        hasImage = true;
      } else if (item.type.startsWith('text/')) {
        hasText = true;
      }
    }

    if (hasImage && hasText) {
      setPastedType('mixed');
    } else if (hasImage) {
      setPastedType('image');
    } else if (hasText) {
      setPastedType('text');
      loadPastedText(pastedItems[0]);
    }

  }, [pastedItems, loadPastedText]);

  const handleAdd = useCallback((selectedFolder, editedBlob) => {
    if (!onAdd || !pastedType) return;

    onAdd({ type: pastedType, blob: editedBlob ?? pastedItems[0], selectedFolderId: selectedFolder?.value });
  }, [onAdd, pastedType, pastedItems]);

  const handleCancel = useCallback(() => {
    if (onCancel) onCancel();
  }, [onCancel]);

  return (
    <div
      className={`flex flex-col min-h-0 h-full ${className}`}
      tabIndex={0}
      role="region"
      aria-label="Paste area"
    >
      {pastedType === 'image' && (
        <CreateImageItem
          imageUrl={URL.createObjectURL(pastedItems[0])}
          onCancel={handleCancel}
          onAdd={handleAdd}
          onDraw={() => {}}
          folderOptions={folderOptions}
          defaultFolderId={defaultFolderId}
        />
      )}

      {pastedType === 'text' && (
        <div className="flex-1 min-h-0">
          <CreateTextItem
            content={pastedText}
            onCancel={handleCancel}
            onAdd={handleAdd}
            onContentTypeSelect={() => {}}
            folderOptions={folderOptions}
            defaultFolderId={defaultFolderId}
          />
        </div>
      )}

      {pastedType === 'mixed' && (
        <div>
          Mixed
        </div>
      )}

      {!pastedType && (
        <div className="w-[500px] h-[540px] flex items-center justify-center rounded-3xl border border-[#ECECEC] dark:border-[#202020] bg-[#FCFCFC] dark:bg-[#1A1A1A] text-sm text-[#7B7B7B] dark:text-[#848484] select-none">
          Press Ctrl+V to paste content
        </div>
      )}
    </div>
  );
}


